//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'SMBG',
  data () {
    return {
      form: {
        a1c: '0',
        recent: '0',
        steroids: '0',
        diabetes: '',
        treatment: ''
      },
      dataList: [
        {value: '1', name: '1型糖尿病'},
        {value: '2', name: '2型糖尿病'},
        {value: '3', name: '妊娠期糖尿病'},
        {value: '4', name: '糖尿病前期'}
      ],
      // 1型糖尿病
      SMBGarr: [{
        model: '胰岛素泵',
        suggest: '每天4次或更多'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '实施更强化的胰岛素治疗方案；SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '实施更强化的胰岛素治疗方案；SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '实施更强化的胰岛素治疗方案；SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '实施更强化的胰岛素治疗方案；SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '每天4次或更多次'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '实施更强化的胰岛素治疗方案；SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '实施更强化的胰岛素治疗方案；SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: '实施更强化的胰岛素治疗方案；SMBG至少和注射胰岛素一样频繁'
      }],
      // 妊娠期糖尿病
      SMBGarr3: [{
        model: '妊娠期糖尿病',
        suggest: '每天4次SMBG直到血糖达标'
      }],
      // 糖尿病前期
      SMBGarr4: [{
        model: '暂无推荐的SMBG模式',
        suggest: '不推荐常规SMBG'
      }],
      SMBGarr2: [{
        model: '胰岛素泵',
        suggest: '每天4次或更多次'
      }, {
        model: '仅基础胰岛素（未达到目标）',
        suggest: '每天2次或更多次，直到达到目标'
      }, {
        model: '预混胰岛素（或NPH，每日两次）',
        suggest: '每天2次或更多次，直到达到目标'
      }, {
        model: '预混胰岛素（或NPH，每日两次）',
        suggest: '每天2次或更多次，直到达到目标'
      }, {
        model: '基础+',
        suggest: 'SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '每日四次（注射基础胰岛素）',
        suggest: 'SMBG至少和注射胰岛素一样频繁'
      }, {
        model: '在过去6个月内被诊断为2型糖尿病或未达到血糖指标',
        suggest: '每天1次或更多次'
      }, {
        model: '在过去6个月内被诊断为2型糖尿病或未达到血糖指标',
        suggest: '每天1次或更多次'
      }, {
        model: '在过去6个月内被诊断为2型糖尿病或未达到血糖指标',
        suggest: '每天1次或更多次'
      }],
      dataList2: [
        {value: '0', name: '胰岛素泵'},
        {value: '1', name: '每日一次胰岛素'},
        {value: '2', name: '每日两次预混胰岛素'},
        {value: '3', name: '每日两次中性鱼精蛋白锌胰岛素'},
        {value: '4', name: '每日一次短效胰岛素/普通胰岛素及每日一次中性鱼精蛋白锌胰岛素/长效胰岛素'},
        {value: '5', name: '每日≥4剂胰岛素'},
        {value: '6', name: '胰岛素促分泌剂'},
        {value: '7', name: '其他药物'},
        {value: '8', name: '未治疗'}
      ],
      hasScore: false,
      disabled: false,
      descTxt: '',
      modelTxt: '',
      suggestTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])

  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let modelTxt = ''; let suggestTxt = ''
      if (form.diabetes === 1 && form.treatment !== '') {
        modelTxt = self.SMBGarr[Number(form.treatment)].model
        suggestTxt = self.SMBGarr[Number(form.treatment)].suggest
      } else if (form.diabetes === 3 && form.treatment !== '') {
        modelTxt = self.SMBGarr3[0].model
        suggestTxt = self.SMBGarr3[0].suggest
      } else if (form.diabetes === 4 && form.treatment !== '') {
        modelTxt = self.SMBGarr4[0].model
        suggestTxt = self.SMBGarr4[0].suggest
      } else if (form.diabetes === 2 && form.treatment !== '') {
        modelTxt = self.SMBGarr2[Number(form.treatment)].model
        suggestTxt = self.SMBGarr2[Number(form.treatment)].suggest
        console.log(form, self.SMBGarr2, form.treatment, 'modelTxt')
        if (form.treatment === 1 && form.a1c === 1) {
          modelTxt = '仅基础胰岛素（针对目标'
          suggestTxt = 'SMBG至少和注射胰岛素一样频繁'
        } else if (form.treatment === 2 && form.a1c === 1) {
          modelTxt = '预混胰岛素（或NPH，每日两次）'
          suggestTxt = 'SMBG至少和注射胰岛素一样频繁'
        } else if (form.treatment === 3 && form.a1c === 1) {
          modelTxt = '预混胰岛素（或NPH，每日两次）'
          suggestTxt = 'SMBG至少和注射胰岛素一样频繁'
        } else if (form.treatment === 4 && form.a1c === 1) {
          modelTxt = '基础+'
          suggestTxt = 'SMBG至少和注射胰岛素一样频繁'
        } else if (form.treatment === 6 && form.recent === 1 && form.steroids !== 1) {
          modelTxt = '在过去6个月内被诊断为2型糖尿病或未达到血糖指标'
          suggestTxt = '每天在不同时间进行一次或多次SMBG，以了解饮食、运动及药物的影响'
        } else if (form.treatment === 6 && form.recent === 0 && form.a1c === 1 && form.steroids !== 1) {
          modelTxt = '2型糖尿病通过生活方式和口服治疗，达到血糖指标'
          suggestTxt = '罕见的SMBG推荐，每周1~2次'
        } else if (form.treatment === 6 && form.steroids === 1) {
          modelTxt = '患者生病或正在服用类固醇药物'
          suggestTxt = '每天2次或更多次'
        }
      }
      self.hasScore = true
      console.log(form, modelTxt, 'modelTxt')
      return {
        model: modelTxt,
        suggest: suggestTxt
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/SMBG.vue